import React from 'react';

import './Checkbox.css';

export const Checkbox = ({
  checked = false,
  color,
  label,
  onChange,
  leftLabel,
  fillStyle,
  leftLabelFlex,
  leftLabelFontSize,
  leftLabelPadding,
  disabled,
  height,
  width,
  error,
}) => {
  const getCheckboxStyle = () => {
    if (disabled)
      return {
        backgroundColor: checked && fillStyle ? '#a0a0a0' : '#f3f3f3',
        cursor: 'not-allowed',
        border: '2px solid #6F8594FF',
        height: height || '20px',
        width: width || '20px',
      };

    return {
      backgroundColor: checked && fillStyle ? color : 'transparent',
      border: error ? '2px solid #E70000FF' : '2px solid #6F8594FF',
      height: height || '20px',
      width: width || '20px',
    };
  };

  const leftLabelStyle = {
    textAlign: 'right',
    fontSize: leftLabelFontSize || '16px',
    color: '#6F8594FF',
    fontWeight: 'bold',
    flex: leftLabelFlex || '0 0 110px',
    paddingRight: leftLabelPadding || '5px',
    paddingLeft: leftLabelPadding || '0',
  };

  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <div className="checkbox-container">
      {leftLabel && <div style={leftLabelStyle}>{leftLabel}</div>}
      <div className={`checkbox ${checked ? 'checked' : ''}`} style={getCheckboxStyle()} onClick={handleClick}>
        {checked && !fillStyle && '✔'}
      </div>
      <input type="checkbox" checked={checked} onChange={handleClick} style={{ display: 'none' }} disabled={disabled} />
      {!leftLabel && <div className="checkbox-label">{label}</div>}
    </div>
  );
};
